const initalStateFilters = () => ({
  "data": [],
  "generalCondition": "and",
  "filterType": "simple",
  "groupedData": [
    {
      "group": 0,
      "data": [
        {
          "group": 0,
          "input": "have_applicants",
          "selectedValueData": {"label": "Si", value: "true"},
          "type": "boolean",
          "operator": "true",
          "compareTo": true,
          "index": 0
        },
      ],
      "groupCondition": "and"
    }
  ]
})

const initialStateQuery = (statusActive) => ({
  q: {
    "g": [
      {
        "m": "and",
        "selection_process_status_id_eq": statusActive.id
      }
    ],
    "m": "and"
  }
})

const createInitialState = (statusActive, isBasicWithUserColumns) => {
  let initialParams = initialStateQuery(statusActive);
  
  // Si se debe mostrar solo procesos con aplicantes
  if (isBasicWithUserColumns) {
    // Aseguramos que existe la estructura correcta para aplicar el filtro
    if (!initialParams.q.g || !initialParams.q.g[0] || !initialParams.q.g[0].g) {
      initialParams.q.g = [{
        m: "and",
        g: []
      }];
    }
    
    // Añadimos el filtro have_applicants_true al primer grupo
    initialParams.q.g[0].g = initialParams.q.g[0].g || [];
    initialParams.q.g[0].g.push({
      m: "and",
      have_applicants_true: true
    });
  }
  
  return initialParams;
};

const metadata = {
  currentPage: 1,
  nextPage: null,
  prevPage: null,
  totalPages: 1,
  totalCount: 0,
};

const haveApplicants = {
  "group": 0,
  "input": "have_applicants",
  "selectedValueData": {"label": "Si", value: "true"},
  "type": "boolean",
  "operator": "true",
  "compareTo": true,
  "index": 0
}

export { initalStateFilters, createInitialState, metadata, haveApplicants }
